export const useLogger = () => {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    return console
  } else {
    return {
      log: () => {},
      error: () => {},
      info: () => {},
      debug: () => {},
      table: () => {},
    }
  }
}
